(function ($){
    // animation action

    var isSafari = window.safari !== undefined;
    if (isSafari){
        $('body').addClass('thisissafari');
    }
    function animationRun(top) {
        $('[data-animation]').not('.animated').each(function() {
            let that = $(this);
            let boxPositionTop = that.offset().top;
            let position = top + $(window).height();

            if (position > boxPositionTop) {
                that.addClass(that.attr('data-animation') + ' animated').trigger('classChange');
            }
        });
    }
    animationRun($(window).height());

    // on scroll
    $(window).scroll(function() {
        animationRun($(window).scrollTop());
    });

    // play video btn
    $('.js-frame').magnificPopup({type:'iframe'});

    // anchor links
    $('a[href^="#"]').on('click', function(event) {
        event.preventDefault();

        let target = $($(this).attr('href'));

        scrollToAnchor(target);
    });



    // init counting
    let observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                startCountingIfNeeded(entry.target, { duration: 4000 });
            }
        });
    }, { threshold: 0.1 });

    $('.js-counter-value').each(function() {
        observer.observe(this);
    });



    function checkAboutUsPagination(){
        let currentUrl = window.location.href,
            targetString = "about-us/page/";

        if (currentUrl.indexOf(targetString) !== -1) {
            scrollToAnchor($('.team').first());
        }
    }
    checkAboutUsPagination();

    function scrollToAnchor(target){
        let margin = $('#header').outerHeight() + 15,
            wpAdminBar = $('#wpadminbar');

        if(wpAdminBar.length > 0){
            margin = margin + wpAdminBar.outerHeight();
        }

        if (target.length) {
            $('html, body').animate({
                scrollTop: (target.offset().top - margin)
            }, 200);
        }
    }

    $('.team__nav-item').click(function (e){
        $('.team__nav-item').removeClass('active');
        $(this).addClass('active');
    });

    $('.team__nav-arrow.right').click(function (e){
        let container = document.querySelector('.team__nav');
        container.scrollTo({
            left: container.scrollLeft + 200,
            behavior: 'smooth',
        });
    });

    $('.team__nav-arrow.left').click(function (e){
        let container = document.querySelector('.team__nav');
        container.scrollTo({
            left: container.scrollLeft - 200,
            behavior: 'smooth',
        });
    });

    let left = document.getElementById("team");
    if (left){
        let stop      = left.offsetTop,
            docBody   = document.documentElement || document.body.parentNode || document.body,
            hasOffset = window.pageYOffset !== undefined,
            scrollTop;

        window.onscroll = function (e) {
            let container = document.querySelector('.team__content');
            let stop_position = container.offsetTop +  container.offsetHeight - 150;

            // cross-browser compatible scrollTop.
            scrollTop = hasOffset ? window.pageYOffset : docBody.scrollTop;

            // if user scrolls to 60px from the top of the left div
            if (scrollTop >= stop && scrollTop < stop_position) {
                // stick the div
                left.style.position = 'fixed';
                left.style.top = '120px';
            }else{
                left.style.position = 'relative';
                left.style.top = 'auto';
            }
        }

        //init search
        let search_arr = {}
        let cards = document.querySelectorAll('.team-card-js');
        cards.forEach(function (card){
            let name = card.getAttribute('data-search');
            search_arr[name] = card;
        });

        let timer;
        const waitTime = 500;
        const messageInput = document.getElementById('team_search');
        messageInput.addEventListener('keyup', event => {
            clearTimeout(timer);

            timer = setTimeout(() => {
                let search_val = event.target.value;

                // Do Search
                for (const [name, block] of Object.entries(search_arr)) {
                    if (!name.match(new RegExp('.*?' + search_val + '.*?', 'i'))){
                        let to_hide = document.querySelectorAll('[data-search="'+name+'"]');
                        to_hide.forEach(b => {b.style.display = 'none'})
                    }else{
                        let to_show = document.querySelectorAll('[data-search="'+name+'"]');
                        to_show.forEach(b => {
                            b.style.display = 'block'
                            b.closest('.team-items-wrap-js').style.display = 'flex';
                        })
                    }
                }

                // Filters
                let items_wrap = document.querySelectorAll('.team-items-js');
                items_wrap.forEach(function (row){
                    let top_row = row.closest('.team-items-wrap-js');
                    let cat_name = top_row.getAttribute('id');
                    if (row.offsetHeight === 0){
                        document.querySelector('.team__nav-item[href="#'+cat_name+'"]').style.display = 'none';
                        top_row.style.display = 'none';
                    }else{
                        document.querySelector('.team__nav-item[href="#'+cat_name+'"]').style.display = 'inline-block';
                        top_row.style.display = 'flex';
                    }
                });

                let team_cont = document.querySelector('.team__container-js');
                let team_not_found = document.querySelector('.team__not-found');
                if (team_cont.offsetHeight === 0){
                    let template = team_not_found.getAttribute('data-template');

                    template = template.replace('[query]', document.getElementById('team_search').value);

                    team_not_found.innerText = template;
                    team_not_found.style.display = 'block';
                }else{
                    team_not_found.style.display = 'none';
                }
            }, waitTime);
        });

    }



}(jQuery));
